module.exports = __webpack_public_path__ + "img/loja-icon.7fefbb54.svg";